import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    deleteButton: {
        padding: "0",
        color: "var(--color-red)"
    },
}));